import { requireAnyOrgPermission, requireAnySystemPermission } from '../../../../../../backend/features/permissions/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../../ui/hooks';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { TransparentBox } from '@juvare/common-web-ui/TransparentBox';
import { Box, Typography } from '@mui/material';
import React from 'react';
import organizationsHeaderImage from '../../../../../assets/organizationsHeaderImage.svg';
export const OrganizationsPageHeader = (props) => {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const userHasPermissions = requireAnySystemPermission(userState, 'manage-organizations', 'all-organizations-admin') ||
        requireAnyOrgPermission(userState, 'manage-members');
    return (React.createElement(PageHeaderWithImage, { gradient: 'orange-dark', title: t('panels.organizations.title'), subtitle: t('panels.organizations.subtitle'), image: organizationsHeaderImage, imageAlt: '' },
        React.createElement(Box, { sx: {
                columnGap: { xs: 2, lg: 3 },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                rowGap: { xs: 2, sm: 0 },
            } },
            React.createElement(Box, { sx: { width: userHasPermissions ? '100%' : { xs: '100%', sm: '50%' } } },
                React.createElement(TransparentBox, { "data-test": 'total-pending-members' },
                    React.createElement(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        } },
                        React.createElement(Typography, { variant: 'body1', sx: {
                                wordWrap: 'break-word',
                                fontSize: '26px',
                                fontWeight: 400,
                                lineHeight: '34px',
                                letterSpacing: '0px',
                            } }, userState.totalUserOrganizations),
                        React.createElement(Typography, { variant: 'body2', sx: { wordWrap: 'break-word' } }, t('panels.organizations.totalOrganizations'))))),
            userHasPermissions && (React.createElement(Box, { sx: { width: '100%' } },
                React.createElement(TransparentBox, { "data-test": 'total-pending-members' },
                    React.createElement(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        } },
                        React.createElement(Typography, { variant: 'body1', sx: {
                                wordWrap: 'break-word',
                                fontSize: '26px',
                                fontWeight: 400,
                                lineHeight: '34px',
                                letterSpacing: '0px',
                            } }, props.pendingMemberships),
                        React.createElement(Typography, { variant: 'body2', sx: { wordWrap: 'break-word' } }, t('panels.organizations.pendingMemberships')))))))));
};
